import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, } from 'react-router-dom';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { InputBox } from "../CommonComponents/InputBox";

const UpdatePickUpRequest = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const ValueNo = searchParams.get('AwbNo');
    const [formData, setFormData] = useState({ awbNo: "" });

    const updateAwbFormfunction = async (value = formData.awbNo) => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/CheckAwbNo', {
            AwbNo: value.trim(), pageType: 'UPD', "Type": "PickUpRequest"
        })
        await dispatch(setSubLoading(false))
        if (data.Status === 'ERROR' || data.Status === 'EXPIRED' || data.Status === 'UNAUTHORIZED') {
           
            await NotificationSound(data.Status, data.Message, data.Focus, inputrefs);
        }
        else if (data.Status === 'SUCCESS') {
            await navigate(`/PickUpRequest?AwbNo=${value.trim()}&PageType=UPD`);
        }
    };
    useEffect(() => {
        if (ValueNo) {
            setFormData({ awbNo: ValueNo });
        }
    }, [ValueNo]);
    useEffect(() => {
        document.title = 'Update PickUp Request';
        inputrefs.current['txtAwbNumber'].focus()
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Update PickUp Request')}</span>
                </div>
                <div className='card-body'>
                    <div className='row'>
                        <InputBox
                            label='Pick Up Ref No '
                            inputrefs={inputrefs}
                            id='txtAwbNumber'
                            value={formData.awbNo}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtbtn'].focus() };
                            }}
                            onChange={(e) => setFormData({ ...formData, awbNo: e.target.value.trim() })}
                            maxLength='25'
                            required={true}
                        />
                        <div className='col-md-2' style={{ marginTop: "16px" }} >
                            <button
                                ref={ref => (inputrefs.current[`txtbtn`] = ref)}
                                onClick={() => updateAwbFormfunction(formData.awbNo)}
                                className="btn btn-rounded btn-primary">
                                <span className=" text-white me-2">
                                </span> {FindTranslatedKey('Validate Ref')}</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdatePickUpRequest;